module.exports = __webpack_public_path__ + "static/media/12.740d69a0.webp";